module.exports = __webpack_public_path__ + "static/img/pUIlD6fg.a1d1a23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/pUIlD6fg.jpg
// module id = KC2D
// module chunks = 7